var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sidebar__container" },
    [
      _c("div", { staticClass: "sidebar__row" }, [
        _c("nav", { staticClass: "links-col" }, [
          _c(
            "ul",
            { staticClass: "links-col__links" },
            _vm._l(_vm.menuItems, function(item, index) {
              return _c("NavMenuItem", { key: index, attrs: { item: item } })
            }),
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("ContactTeamMenu"),
      _vm._v(" "),
      _c("div", { staticClass: "sidebar__row" }, [_c("LogoutItem")], 1)
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }